import createReducer from '../utils/createReducer';
import actions from '../actions/actions';

const initialState = {};

const actionHandlers = {
    [actions.FETCH_CONTENT_SUCCESS](state, {payload}) {
        return {
            ...state,
            ...payload.response.content
        };
    }
};

export default createReducer(actionHandlers, initialState);
